import React, { useState, useEffect } from 'react';
import { LOCALE_RU } from '../../../constant';
import { useParams } from 'react-router-dom';
import { formNamesService } from '../../../services/formNamesService';
import PageTitleAsBreadCrumbs from '../../../shared/PageTitleAsBreadCrumbs';
import { formSaveService } from '../../../services/formSaveService';
import ItemName from '../../../shared/ItemName';
import NonEditableItemCode from '../../../shared/NonEditableItemCode';
import FormItemType from './FormItemType';
import LastUpdateTime from '../../../shared/LastUpdateTime';
import ItemProductCategory from '../../../shared/ItemProductCategory';
import { useTranslation } from 'react-i18next';

const EditFormTab = () => {
    const { i18n } = useTranslation();
    const [activeFormItem, setActiveFormItem] = useState({});
    const { id } = useParams();

    const successGetForms = (response) => {
        setActiveFormItem({...response, locales:[], locale:LOCALE_RU});
    };

    useEffect(() => {
        if(id) {
            formSaveService.loadForm(id, successGetForms, i18n);
        }
    }, [id]);

    return (
        <>
            <PageTitleAsBreadCrumbs />
            <article className="product__article product__article-add">
                <LastUpdateTime itemSaveService={formSaveService}/>
                <form className="product__form product__form_large">
                    <ItemName itemCode={activeFormItem} itemService={formNamesService} itemSaveService={formSaveService}/>
                    <NonEditableItemCode itemCode={activeFormItem.productForm} />
                    <ItemProductCategory itemsStorageService={formSaveService} />
                    <FormItemType />
                </form>
            </article>
        </> 
    );
};

export default EditFormTab;
